import _ from 'lodash'
import Text from "theme/Text";
import { ProfileStyles } from 'scenes/home/more/profile/styles/ProfileStyles'
import i18n from 'utils/i18n'
import { View } from 'react-native'
import ThemedBlock from 'components/atoms/ThemedBlock'
import React from 'react'

const ProfileErrors = ({ errors }) => {
	
	if( _.size( errors ) === 0 ) {
		return null;
	}
	
	return (
		<ThemedBlock
			mediumPadding
			shadow>
			
			<Text style={ ProfileStyles.errorHeader }>{ i18n.t( `pages.more.profile.resolve_error` ) }</Text>
			
			{ _.map( errors, ( error ) => {
				return (
					<View style={ ProfileStyles.errorContainer }>
						<Text style={ ProfileStyles.errorText }>
							{ i18n.t( `pages.more.profile.errors.${error}`) }
						</Text>
					</View>
				);
			}) }
		</ThemedBlock>
	)
}

export default ProfileErrors
